jQuery(document).ready(function ($) {
  let countryFK;
  let tournamentFK;
  let tournament_stage_id;
  let match_id;
  let competitors;
  let round;
  let status;
  let formattedDate;
  let tipCategories;
  let competition;
  let accessToken = null;


  // Function to make authenticated API calls
  async function makeAuthenticatedRequest(endpoint, data = {}) {
    // Use WordPress REST API endpoint instead of direct API call
    const proxyUrl = `/wp-json/oddsnet/v1/proxy/${endpoint}`;
    
    return $.ajax({
      url: proxyUrl,
      data: data,
      method: 'GET',
      dataType: 'json',
      headers: {
        'X-WP-Nonce': myApiSettings.nonce 
      }
    });
  }


  $(".sports-data-api-button").click(async function (e) {
    $(".sports-data-fields").removeClass("d-none");
    try {
      const response = await makeAuthenticatedRequest("basic/countries", {
        limit: 5000
      });
      
      $(".country-results").css("display", "flex");
      let countryFK = response.results;
      countryFK.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      let $dropdown = $(".country-results select");
      $dropdown.empty();
      $dropdown.append($("<option selected />").text("Velg land"));
      $.each(countryFK, function () {
        $dropdown.append($("<option />").val(this.id).text(this.name));
      });
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
    e.preventDefault();
  });

  $(".country-results").change(async function (e) {
    let countryFK = e.target.value;
    try {
      const response = await makeAuthenticatedRequest("tournament-templates", {
        sport: 1,
        limit: 10000,
        country: countryFK
      });

      $(".country-soccer-leagues").css("display", "flex");
      let tournament_template = response.results;
      let $dropdown = $(".country-soccer-leagues select");
      $dropdown.empty();
      $dropdown.append($("<option selected />").text("Velg turnering"));
      if (tournament_template == 0) {
        $dropdown.append(
          $("<option selected />").text("Ingen kamper tilgjengelig")
        );
      } else {
        $.each(tournament_template, function () {
          $dropdown.append(
            $("<option />")
              .val(this.id)
              .text(this.name + " (" + this.gender + ")")
          );
        });
      }
    } catch (error) {
      console.error("Error fetching tournament templates:", error);
    }
  });

  $(".country-soccer-leagues").change(async function (e) {
    tournamentFK = e.target.value;
    try {
      const response = await makeAuthenticatedRequest("basic/tournaments", {
        limit: 10000,
        sport: 1,
        name: countryFK,
        tournament_template: tournamentFK
      });

      $(".soccer-league-years").css("display", "flex");
      let tournaments = response.results;
      let $dropdown = $(".soccer-league-years select");
      $dropdown.empty();
      $dropdown.append($("<option selected />").text("Velg år"));
      if (tournaments == 0) {
        $dropdown.append(
          $("<option selected />").text("Ingen år tilgjengelig")
        );
      } else {
        $.each(tournaments, function () {
          $dropdown.append($("<option />").val(this.id).text(this.name));
        });
      }
    } catch (error) {
      console.error("Error fetching tournaments:", error);
    }
  });

  $(".soccer-league-years").change(async function (e) {
    tournamentFK = e.target.value;
    try {
      const response = await makeAuthenticatedRequest("basic/tournament-stages", {
        limit: 1000,
        sport: 1,
        name: countryFK,
        tournament: tournamentFK
      });

      $(".soccer-league").css("display", "flex");
      let tournament_stages = response.results;
      let $dropdown = $(".soccer-league select");
      $dropdown.empty();
      $dropdown.append($("<option selected />").text("Velg"));
      $.each(tournament_stages, function () {
        $dropdown.append($("<option />").val(this.id).text(this.name));
      });
    } catch (error) {
      console.error("Error fetching tournament stages:", error);
    }
  });

  $(".soccer-league").change(function (e) {
    tournament_stage_id = e.target.value;
    $(".event-date").css("display", "flex");
  });

  $(".event-date").change(async function (e) {
    let selected_date = new Date($("#event-date").val());
    let format_selected_date = selected_date.toISOString().split("T")[0];
    try {
      const response = await makeAuthenticatedRequest("events", {
        date: format_selected_date,
        tournament_stage: tournament_stage_id,
        tournament: tournamentFK,
        sport: 1,
        name: countryFK
      });

      $(".soccer-match").css("display", "flex");
      let soccer_matches = response.results;
      let $dropdown = $(".soccer-match select");
      $dropdown.empty();
      if (soccer_matches.length == 0) {
        $dropdown.append(
          $("<option selected />").text("Ingen kamper på denne datoen")
        );
      } else {
        $dropdown.append($("<option selected />").text("Velg"));
        $.each(soccer_matches, function () {
          $dropdown.append($("<option />").val(this.id).text(this.name));
        });
      }
      $dropdown.off('change').on('change', function() {
        $('.sports-data-fields input[name="soccer-match-title"]').remove();
        $('.sports-data-fields input[name="soccer-match-date"]').remove();
        // Get the selected option
        let selectedOption = $(this).find('option:selected');
        
        if (selectedOption.val()) {
          let selectedMatch = soccer_matches.find(match => match.id == selectedOption.val());
          
          // Create a new hidden input element for the match title
          var soccerInput = $("<input>");
          soccerInput.attr("type", "hidden");
          soccerInput.attr("name", "soccer-match-title");
          soccerInput.val(selectedOption.text());
          $('.sports-data-fields').append(soccerInput);
  
          // Create a new hidden input element for the match date
          var dateInput = $("<input>");
          dateInput.attr("type", "hidden");
          dateInput.attr("name", "soccer-match-date");
          dateInput.val(selectedMatch.start_date);
          $('.sports-data-fields').append(dateInput);
        }
      });
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  });

  $(".soccer-match").click(async function (e) {
    let match_id = e.target.value;
    if (match_id !== undefined && match_id !== null) {
      try {
        const eventResponse = await makeAuthenticatedRequest(`events/${match_id}`);
        
        let date = new Date(eventResponse.start_date);
        let formattedDate =
          ("0" + (date.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + date.getDate()).slice(-2) +
          " " +
          ("0" + date.getHours()).slice(-2) +
          ":" +
          ("0" + date.getMinutes()).slice(-2);
        
        let competitors = eventResponse.name;
        let round = eventResponse.round.name;
        let status = eventResponse.status.name;
        let competition = eventResponse.name;
        let competitionDetails = {
          id: eventResponse.competition.id,
          name: eventResponse.competition.name,
          startDate: eventResponse.competition.start_date,
          endDate: eventResponse.competition.end_date,
          countryId: eventResponse.competition.country.id,
          countryName: eventResponse.competition.country.name,
          type: eventResponse.competition.type,
          international: eventResponse.competition.international
        };

        const oddsResponse = await makeAuthenticatedRequest(
          `events/${match_id}/odds/1x2`,
          { providers: 'betinia,1bet,vulkanbet,stake,bcgame' }
        );

        let odds_json =
          '"' +
          "Match" +
          '": {"match_id": "' +
          match_id +
          '","competitors": "' +
          competitors +
          '","round": "' +
          round +
          '","status": "' +
          status +
          '","date": "' +
          formattedDate +
          '","competition": {"id": "' +
          competitionDetails.id +
          '","name": "' +
          competitionDetails.name +
          '","start_date": "' +
          competitionDetails.startDate +
          '","end_date": "' +
          competitionDetails.endDate +
          '","country_id": "' +
          competitionDetails.countryId +
          '","country_name": "' +
          competitionDetails.countryName +
          '","type": "' +
          competitionDetails.type +
          '","international": "' +
          competitionDetails.international +
          '"}},';
        $.each(oddsResponse, function () {
          odds_json +=
            '"' +
            this.odds_provider.name +
            '": {"X": "' +
            ((this.offers[0].offer_type === "X"
              ? this.offers[0].odds
              : "") ||
              (this.offers[1].offer_type === "X"
                ? this.offers[1].odds
                : "") ||
              (this.offers[2].offer_type === "X"
                ? this.offers[2].odds
                : "")) +
            '","1": "' +
            ((this.offers[1].offer_type === "1"
              ? this.offers[1].odds
              : "") ||
              (this.offers[2].offer_type === "1"
                ? this.offers[2].odds
                : "") ||
              (this.offers[0].offer_type === "1"
                ? this.offers[0].odds
                : "")) +
            '","2": "' +
            ((this.offers[2].offer_type === "2"
              ? this.offers[2].odds
              : "") ||
              (this.offers[1].offer_type === "2"
                ? this.offers[1].odds
                : "") ||
              (this.offers[0].offer_type === "2"
                ? this.offers[0].odds
                : "")) +
            '","url": "' +
            this.odds_provider.url +
            '","short_code": "' +
            this.odds_provider.short_code +
            '"},';
        });
        odds_json = "{" + odds_json.replace(/,\s*$/, "") + "}";
        $(".match-information-status").val(status);
        $("#post_odds").val(odds_json);
      } catch (error) {
        console.error("Error fetching match data:", error);
      }
    }
  });
  
  $(".clear-all-data-button").click(function (e) {
    $(".select-option select").empty();
    $("#event-date").val("");
    $(".select-option ").css("display", "none");
    e.preventDefault();
  });
});
